/**
 * ExternalSiteIcon — favicon-with-Globe-fallback for external-link
 * pages and sites.
 *
 * The previous inline pattern set `display: none` on img.onError,
 * which left the row icon-less when the favicon URL was unreachable
 * (e.g. MySupport's favicon returned non-image bytes — the img was
 * hidden and no Globe ever rendered). React state on each row lets us
 * cleanly swap to the Globe fallback instead. Used by both
 * `Sidebar.tsx` (root external sites) and `SiteNavTree.tsx` (child
 * external pages).
 */
import { useState, type FC } from 'react';
import { Globe } from 'lucide-react';

interface Props {
  faviconUrl?: string | null;
  size: number;
  className?: string;
}

const ExternalSiteIcon: FC<Props> = ({ faviconUrl, size, className }) => {
  const [broken, setBroken] = useState(false);
  if (!faviconUrl || broken) {
    return <Globe size={size} className={className} />;
  }
  return (
    <img
      src={faviconUrl}
      alt=""
      width={size}
      height={size}
      className={className}
      style={{ borderRadius: 2 }}
      onError={() => setBroken(true)}
    />
  );
};

export default ExternalSiteIcon;
